import { render, staticRenderFns } from "./s-tabbar.vue?vue&type=template&id=a4f8e9a0&"
import script from "./s-tabbar.vue?vue&type=script&lang=js&"
export * from "./s-tabbar.vue?vue&type=script&lang=js&"
import style0 from "./s-tabbar.vue?vue&type=style&index=0&id=a4f8e9a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports